<div
  class="not-found flex flex-col justify-center items-center text-center h-full gap-lg p-2xl">
  <h1 class="error-code font-extrabold text-primary-500">404</h1>

  <h5 class="text-2xl font-bold text-neutral-900">
    {{ 'not_found_screen_title' | transloco }}
  </h5>

  <p class="font-medium text-sm text-neutral-500">
    {{ 'not_found_screen_description' | transloco }}
  </p>

  <button
    type="button"
    id="not_found_screen_back_to_login"
    (click)="goToLogin()"
    class="rounded-md py-sm px-2xl bg-primary-500 text-white text-lg font-medium mt-lg">
    {{ 'not_found_screen_back_to_login' | transloco }}
  </button>
</div>
